<template>
  <div class="group-box" :class="{ 'is-edit': mode === 'edit' }">
    <div class="group-title" v-if="!group.isHideTitle">
      <text-box
        type="editor"
        :mode="mode"
        :image-style="{ height: '22px' }"
        :value="group.title || '分组标题'"
        @onChange="value => handleTitleChange(value)"
      >
        {{ group.title || "分组标题" }}
      </text-box>
    </div>
    <draggable
      class="group-list"
      v-model="contentList"
      :animation="200"
      :disabled="mode !== 'edit'"
      :group="'audioInfoGroupList'"
      :ghostClass="'ghost'"
      :handle="'.edit-drag'"
      @start="dragContent = true"
      @end="dragContent = false"
      @change="handleSortContentList"
    >
      <template v-if="group.content && group.content.length > 0">
        <div
          class="group-item"
          v-for="(data, index) in contentList.slice(0, group.showLength !== 'all' ? 2 : group.content.length)"
          :key="data.key"
        >
          <audio-box
            :mode="mode"
            :data="data"
            @onAdd="handleAddContentItem(index)"
            @onDelete="handleDeleteContentItem(index)"
            @onChange="value => handleChangeContentItem(index, value)"
          ></audio-box>
        </div>
      </template>
      <template v-else-if="mode === 'edit'">
        <button class="add-btn" @click.stop="handleAddContentItem(0)">
          <i class="icon wiki-editable-add"></i>
        </button>
      </template>
    </draggable>
    <div class="list-more" v-if="group.content && group.content.length > 2">
      <button class="more-btn" :class="{ close: group.showLength === 'all' }" @click="handleShowMore">
        {{ group.showLength === "all" ? "收起" : "更多" }}
        <span class="icon"></span>
      </button>
    </div>
    <div class="edit-btns-wrapper" v-if="mode == 'edit'">
      <edit-btns
        :edit-btns="['drag', 'setup', 'delete', 'add']"
        @onSetup="handleOpenListItemSetup"
        @onDelete="handleDelete"
        @onAdd="handleAdd"
      ></edit-btns>
    </div>
    <!-- 设置 -->
    <setup-panel
      v-if="mode === 'edit'"
      ref="setupPanel"
      :data="group"
      :isShowTabs="isShowTabs"
      :tabs="tabs"
      @onChange="handleListItemSetup"
    ></setup-panel>
  </div>
</template>

<script>
import draggable from "vuedraggable";
// components
import TextBox from "../../../../components/TextBox";
import AudioBox from "../AudioBox";
import SetupPanel from "./SetupPanel";
import EditBtns from "../../../../components/EditBtns";

export default {
  name: "GroupBox",
  components: {
    draggable,
    TextBox,
    AudioBox,
    SetupPanel,
    EditBtns
  },
  props: {
    mode: String,
    group: {
      type: Object,
      default: () => ({})
    },
    isShowTabs: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dragContent: false,
      contentList: []
    };
  },
  watch: {
    group: {
      handler(val) {
        this.contentList = val.content;
      },
      immediate: true
    }
  },
  mounted() {},

  methods: {
    // 添加
    handleAdd() {
      this.$emit("onAdd");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    // 打开设置
    handleOpenListItemSetup() {
      this.$refs.setupPanel.open();
    },
    // item 设置
    handleListItemSetup(data) {
      this.$emit("onChange", data);
    },
    // 修改分组标题
    handleTitleChange(title) {
      const group = this.group;
      group.title = title;
      this.$emit("onChange", group);
    },
    // 列表排序
    handleSortContentList() {
      const group = this.group;
      group.content = this.contentList;
      this.$emit("onChange", group);
    },
    // 列表添加
    handleAddContentItem(index = 0) {
      const group = this.group;
      group.content.splice(index + 1, 0, {
        key: Math.random().toString(16),
        audio: "",
        name: "",
        desc: ""
      });
      this.$emit("onChange", group);
    },
    // 列表删除
    handleDeleteContentItem(index = 0) {
      const group = this.group;
      group.content.splice(index, 1);
      this.$emit("onChange", group);
    },
    // 列表内容change
    handleChangeContentItem(index, value) {
      const group = this.group;
      group.content.splice(index, 1, value);
      this.$emit("onChange", group);
    },
    // 显示更多
    handleShowMore() {
      const group = this.group;
      if (group.showLength == "all") {
        group.showLength = 2;
      } else {
        group.showLength = "all";
      }
      this.$emit("onChange", group);
    }
  }
};
</script>

<style lang="less" scoped>
.is-edit {
  &:hover {
    outline: #c7ccd5;
    outline-style: solid;
    outline-width: 3px;
    .edit-btns-wrapper {
      display: inline-flex;
    }
  }
}
.edit-btns-wrapper {
  display: none;
  position: absolute;
  box-sizing: content-box;
  height: 20px;
  right: -92px;
  top: 0;
  padding-bottom: 3px;
  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
.group-box {
  position: relative;
  width: 100%;
  margin-bottom: 26px;
}
.group-title {
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  color: #212121;
  line-height: 28px;
  margin-bottom: 20px;
}
.group-list {
  width: 100%;
  .group-item {
    width: 100%;
    margin-bottom: 12px;
  }
}

.list-more {
  width: 100%;
  text-align: right;
  .more-btn {
    width: 51px;
    height: 24px;
    background: #373737;
    border-radius: 4px;
    text-align: center;
    border: none;
    padding: 0;
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    line-height: 24px;
    .icon {
      display: inline-block;
      vertical-align: middle;
      width: 0;
      height: 0;
      border-top: 6px solid #fff;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 2px solid transparent;
      border-radius: 2px;
    }
  }
  .close {
    .icon {
      transform: rotate(180deg) translateY(2px);
    }
  }
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
